import RefBasedDimensionsProvider from "./providers/RefBasedDimensionsProvider";
import ResizeBasedDimensionsProvider from "./providers/ResizeBasedDimensionsProvider";

interface ParentDimensionsProviderProps {
  type?: "resize" | "ref";
  children?: React.ReactElement;
}

/**
 * Use Case
 *
 * In browser, the dashboard uses the Resize listener approach but this is async and can cause issues with the screen shot for PDF Reports.
 * As a result of the debounce, the screen shot for PDF Reports is taken before the resize event updates the chart dimensions.
 *
 * Instead of using Resize listener, the Ref approach is used for PDF Reports. This is synchronous and updates the correct dimensions using `useLayoutEffect`.
 */
function ParentDimensionsProvider(props: ParentDimensionsProviderProps) {
  if (props.type === "ref") {
    return <RefBasedDimensionsProvider>{props.children}</RefBasedDimensionsProvider>;
  }

  return <ResizeBasedDimensionsProvider>{props.children}</ResizeBasedDimensionsProvider>;
}

export default ParentDimensionsProvider;
